<template>
  <v-dialog width="800" persistent v-model="isShow">
    <CalendarPublisherEditor
      :isShow="isEditorShow"
      :target="targetGroup"
      @close="closeEditor"
      @save="saveEditor"
    ></CalendarPublisherEditor>
    <v-card>
      <v-toolbar color="primary" dark>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="close">mdi-close</v-icon>
      </v-toolbar>
      <div>
        <v-data-table
          :items="calendar.events"
          :headers="hearders"
          :items-per-page="5"
          dense
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Calendar Summary</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
          <template v-slot:item.startDateTime="{ item }">
            {{ getDate(item.startDateTime) }}
          </template>
          <template v-slot:item.endDateTime="{ item }">
            {{ getDate(item.endDateTime) }}
          </template>
        </v-data-table>
      </div>

      <div>
        <v-data-table
          :items="subscriptions"
          :headers="subscriptionHearders"
          :items-per-page="999"
          hide-default-footer
          dense
          class="pb-5"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Target</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <!--  <v-btn color="primary" @click="openEditor">NEW TARGET</v-btn> -->
            </v-toolbar>
            <CalendarPublisherIntegratedEditor
              :target="targetGroup"
              @save="saveEditor"
            ></CalendarPublisherIntegratedEditor>
          </template>
          <template v-slot:item.isActive="{ item }">
            <!-- <v-icon
              :color="item.isActive ? 'green' : 'red'"
              @click="
                item.isActive = !item.isActive;
                saveEditor(item);
              "
              >mdi-circle</v-icon
            >-->
            <v-btn
              :color="item.isActive ? 'green' : 'red'"
              outlined
              x-small
              width="60"
              @click="
                item.isActive = !item.isActive;
                saveEditor(item);
              "
              >{{ item.isActive ? "Enabled" : "Disabled" }}</v-btn
            >
          </template>
          <template v-slot:item.group="{ item }">
            {{ getGroupName(item) }}
          </template>
          <template v-slot:item.range="{ item }">
            {{ item.isAll ? "All Dates" : item.start + " - " + item.end }}
          </template>
          <template v-slot:item.methods="{ item }">
            {{ item.canSubscribe ? "Subscribe" : "" }}
            {{ item.canPush ? "Push" : "" }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon @click="editItem(item)" class="mr-2">mdi-pencil</v-icon>
            <v-icon @click="deleteItem(item)" class="mr-2">mdi-delete</v-icon>
            <v-icon @click="pushItem(item)" v-show="item.canPush"
              >mdi-export</v-icon
            >
          </template>
        </v-data-table>
      </div>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="publish(true)" class="primary" v-if="(this.subscriptions.length > 0 && !this.subscriptions[this.subscriptions.length-1].isActive)">Publish</v-btn>
         <v-btn class="primary" v-if="this.subscriptions.length > 0 && this.subscriptions[this.subscriptions.length-1].isActive" disabled>Published</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { calService } from "@/api/cal-service";
import moment from "moment";
import CalendarPublisherEditor from "@/components/Modals/CalendarPublisherEditor";
import CalendarPublisherIntegratedEditor from "@/components/Modals/CalendarPublisherIntegratedEditor";
import { mapGetters } from "vuex";

export default {
  name: "CalendarPublisherModal",
  props: { isShow: Boolean, calendar: Object },
  components: { CalendarPublisherEditor, CalendarPublisherIntegratedEditor },
  computed: {
    ...mapGetters(["groupList"]),
  },
  data: () => {
    return {
      title: "Publish",
      isEditorShow: false,
      tab: 0,
      subscriptions: [],
      targetGroup: {
        identity: "",
        calendarId: "",
        groups: [],
        isAll: true,
        start: "",
        end: "",
        canSubscribe: true,
        canPush: false,
        isActive: false,
      },
      currentEvent: {
        identity: "",
        name: "",
        startDateTime: "",
        endDateTime: "",
      },
      hearders: [
        { text: "Name", value: "name", width: "25%", sortable:false },
        { text: "Start", value: "startDateTime", width: "10%", sortable:false },
        { text: "End", value: "endDateTime", width: "10%", sortable:false },
      ],
      subscriptionHearders: [
        //   { text: "", value: "isActive", width: "5%" },

        { text: "Target Group", value: "group", width: "25%", sortable:false },
        { text: "Date Range", value: "range", width: "20%", sortable:false },
        { text: "Methods", value: "methods", width: "20%", sortable:false },
        { text: "Actions", value: "actions", width: "15%", sortable:false },
      ],
      groups: [
        { identity: "ASO", name: "ASO" },
        { identity: "HR", name: "HR" },
      ],
      menu1: false,
      menu2: false,
    };
  },
  async mounted() {
    if (!this.groupList) await this.$store.dispatch("getGroupList");
  },
  methods: {
    getDate(date){
      return moment(date).format('YYYY-MM-DD')
    },
    async publish(flag){
      await calService.pubCal(this.calendar.identity, flag)
      this.subscriptions = await calService.getTarget(this.calendar.identity);
    },
    close() {
      //this.calendar = {};
      this.tab = 0;
      this.currentEvent = {
        identity: "",
        name: "",
        startDateTime: "",
        endDateTime: "",
      };
      this.$emit("close", "close");
    },
    async save() {
      if (!this.calendar.identity) this.calendar.identity = this.guid();

      await calService.updateCal(this.calendar);
      //this.close();
    },
    clear() {
      this.currentEvent = {
        identity: "",
        name: "",
        startDateTime: "",
        endDateTime: "",
      };
    },
    async add() {
      this.currentEvent.identity = this.guid();
      this.calendar.events.push(this.currentEvent);
      let _pattern = this.calendar.events;
      _pattern.sort(
        (a, b) =>
          moment(a.startDateTime).valueOf() - moment(b.startDateTime).valueOf()
      );

      await calService.updateCal(this.calendar);
    },
    editItem(item) {
      this.targetGroup = item;
      this.isEditorShow = true;
    },
    async deleteItem(item) {
      //if (item.isActive) {
      //  alert("You must make this target as inactive before try to delete it");
      //  return;
      //}
      let yes = confirm("Do you want to delete this target?");
      if (yes) {
        let idx = this.subscriptions.findIndex(
          (x) => x.identity == item.identity
        );
        if (idx != -1) this.subscriptions.splice(idx, 1);
        await calService.delTarget(item);
      }
    },
    async update() {
      let idx = this.calendar.events.findIndex(
        (x) => x.identity == this.currentEvent.identity
      );
      if (idx != -1) this.calendar.events.splice(idx, 1);
      this.calendar.events.push(this.currentEvent);
      let _pattern = this.calendar.events;
      _pattern.sort(
        (a, b) =>
          moment(a.startDateTime).valueOf() - moment(b.startDateTime).valueOf()
      );

      await calService.updateCal(this.calendar);

      //console.log("updated");
    },
    guid() {
      var d = new Date().getTime();
      var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (d + Math.random() * 16) % 16 | 0;
          d = Math.floor(d / 16);
          return (c == "x" ? r : (r & 0x7) | 0x8).toString(16);
        }
      );
      return uuid;
    },
    openEditor() {
      this.isEditorShow = true;
    },
    getGroupName(item) {
      return item ? this.groupList.find(x=>x.identity == item.groupId).name : ""; //groups.map((x) => x.name).join(", ");
    },
    async saveEditor(item) {
      let isCreate = !item.identity ? true : false;

      this.isEditorShow = false;
      this.targetGroup = {
        identity: "",
        calendarId: "",
        groups: [],
        isAll: true,
        start: "",
        end: "",
        canSubscribe: true,
        canPush: false,
        isActive: false,
      };

      if (!item.identity) item.identity = this.guid();

      item.calendarId = this.calendar.identity;
      item.isActive = false;

      //let idx = this.subscriptions.findIndex(
      //  (x) => x.identity == item.identity
      //);

      //if (idx != -1) this.subscriptions.splice(idx, 1);

      //this.subscriptions.push(item);

      if (isCreate) await calService.createTarget(item);
      else await calService.updateTarget(item);

      this.subscriptions = await calService.getTarget(this.calendar.identity);
      this.subscriptions[this.subscriptions.length-1].isActive = false;
    },
    closeEditor() {
      this.targetGroup = {
        identity: "",
        calendarId: "",
        groups: [],
        isAll: true,
        start: "",
        end: "",
        canSubscribe: true,
        canPush: false,
        isActive: false,
      };
      this.isEditorShow = false;
    },
  },
  watch: {
    calendar: {
      async handler() {
        if (this.calendar.identity) {
          this.subscriptions = await calService.getTarget(
            this.calendar.identity
          );

          this.title = "Publish " + this.calendar.name;
        } else this.title = "Publish";
        //this.tab = 0
      },
      deep: true,
    },
  },
};
</script>

<style>
</style>